import { html } from "lit";
import "../../atom/Text/index.js";
import "../SelectBase/index.js";
import "../PaginationSizeButton/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./paginationSize.selectors.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfPaginationSize = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_open = false;
    this.dsf_flip = true;
    this.dsf_shift = true;
    this.dsf_hide = false;
    this.dsf_open_on_focus = false;
    this.dsf_accessibility_label = "";
    this.dsf_breakout = false;
  }
  handleChange(ev) {
    this.value = ev.detail.length ? parseInt(ev.detail[0]) : void 0;
    this.emit({ name: "input", payload: this.value });
    this.emit({ name: "change", payload: this.value });
  }
  handleOpenChanged(ev) {
    this.dsf_open = ev.detail;
  }
  render() {
    const baseValue = this.value ? [String(this.value)] : [];
    return html`
      <span class="flex items-center p-4 pr-6" data-skeleton>
        <dsf-select-base
          class="cursor-pointer"
          exportparts="dropdown,list"
          dsf_accessibility_label=${this.dsf_accessibility_label}
          .value=${baseValue}
          .dsf_open=${this.dsf_open}
          .dsf_flip=${this.dsf_flip}
          .dsf_shift=${this.dsf_shift}
          .dsf_hide=${this.dsf_hide}
          .dsf_open_on_focus=${this.dsf_open_on_focus}
          .dsf_breakout=${this.dsf_breakout}
          @change=${this.handleChange}
          @open-changed=${this.handleOpenChanged}
        >
          <dsf-pagination-size-button
            slot="button"
            .dsf_open=${this.dsf_open}
            ${testingAttr(TestingAttrs.paginationSizeButton)}
          >
          </dsf-pagination-size-button>
          <slot></slot>
        </dsf-select-base>
        <dsf-text dsf_level="xxs" dsf_color="neutral" dsf_color_intensity="400">
          ${this.dsf_text}
        </dsf-text>
      </span>
    `;
  }
};
__decorateClass([
  prop({ type: Number })
], DsfPaginationSize.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_open", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSize.prototype, "dsf_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_flip", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_shift", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_hide", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_open_on_focus", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSize.prototype, "dsf_accessibility_label", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSize.prototype, "dsf_breakout", 2);
__decorateClass([
  preventDefault
], DsfPaginationSize.prototype, "handleChange", 1);
DsfPaginationSize = __decorateClass([
  defineElement("dsf-pagination-size")
], DsfPaginationSize);
export {
  DsfPaginationSize
};
